import type { FaireProductEntity } from "../../entity_types/product";

export const p_axpndctqpb: FaireProductEntity = {
  token: "p_axpndctqpb",
  type: "product",
  name: "Mahjong Coin Purse, Mahj Fund, Beaded Bag",
  brandToken: "b_qw4qu9fve6",
  brandName: "Lily Posh",
  imageUrl:
    "https://cdn.faire.com/fastly/18e7b0650a3e4b6a88b17c9799181b19396693ae140f71ae63fa0412269e389a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1cd6eb88bb4601ceb0929e0aa522c292bb31e0c0b846dbce11977e51d8b92a84.png",
    "https://cdn.faire.com/fastly/9926a177bfa55d8f9c2271a2c5380bc603123fcb8b95a3afcf2cc76481a3ca9b.png",
    "https://cdn.faire.com/fastly/30710d6a37efe886051772699b11d53b01ea623a462408ba46cf910de8e7775c.png",
  ],
  priceDollars: 23,
  description:
    'Lily Posh Coin Purse\n\nBeading front only\n\nSize: approx. 5.5" x 4.5"\n\n100% Cotton\n\nHand Made',
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:46.631Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
